var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st0",
    d: "M20.4,3.6c-0.2-0.2-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4L12,10.1L5.5,3.6 C5.2,3.4,4.9,3.2,4.5,3.2S3.8,3.4,3.6,3.6C3.1,4.1,3.1,5,3.6,5.5l6.5,6.5l-6.5,6.5c-0.5,0.5-0.5,1.4,0,1.9s1.4,0.5,1.9,0l6.5-6.5 l6.5,6.5c0.5,0.5,1.4,0.5,1.9,0s0.5-1.4,0-1.9L13.9,12l6.5-6.5C20.9,5,20.9,4.1,20.4,3.6z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cgk8cGF0aCBpZD0icGF0aC0xXzFfIiBjbGFzcz0ic3QwIiBkPSJNMjAuNCwzLjZjLTAuMi0wLjItMC42LTAuNC0wLjktMC40Yy0wLjQsMC0wLjcsMC4xLTAuOSwwLjRMMTIsMTAuMUw1LjUsMy42CgkJQzUuMiwzLjQsNC45LDMuMiw0LjUsMy4yUzMuOCwzLjQsMy42LDMuNkMzLjEsNC4xLDMuMSw1LDMuNiw1LjVsNi41LDYuNWwtNi41LDYuNWMtMC41LDAuNS0wLjUsMS40LDAsMS45czEuNCwwLjUsMS45LDBsNi41LTYuNQoJCWw2LjUsNi41YzAuNSwwLjUsMS40LDAuNSwxLjksMHMwLjUtMS40LDAtMS45TDEzLjksMTJsNi41LTYuNUMyMC45LDUsMjAuOSw0LjEsMjAuNCwzLjZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };